module.exports = __webpack_public_path__ + "img/Surveys _Offered Features.a574d199.svg";